// We only need to import the modules necessary for initial render
import CoreLayout from '../layouts/PageLayout/PageLayout'


import Home from './Home'
import KnowlegePage from './KnowlegePage'
import NotFoundDetected from './NotFoundDetected'

import NotFound from './NotFound'

export const createRoutes = (store) => ({

  path: '/',
  indexRoute: Home,
  childRoutes: [
    {
      childRoutes: [
        NotFoundDetected(store),
      ]
    },
    {
      component: CoreLayout,
      childRoutes: [
        KnowlegePage(store),
      ]
    },
    {
      childRoutes: [
        NotFound(store),
      ]
    },
  ]
})

export default createRoutes


// WEBPACK FOOTER //
// ./src/routes/index.js